import React from 'react';
import './index.less';

var View = React.createClass({
    render: function () {
        var {className = ''} = this.props;
        return (
            <div className={"header " + className}>
                <div className="container clearfix">
                    <div className="fr">
                        <i className="iconfont icon-tel"/>
                        <span className="tel">客服电话：400-626-9912</span>
                    </div>
                    <a href="/" className="logo"/>
                </div>
            </div>
        )
    }
});

export default View;


// WEBPACK FOOTER //
// ./components/common/header.jsx